import React from "react";
import styles from "./index.module.css";
import badge from "@/assets/images/svip_badage.png";

const Module = () => {
  return (
    <>
      <div className={styles.module}>
        <div className={styles.moduleTitle}>
          <div>
            动态模式全新推出，让PPT汇报更生动
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
              src={badge.src}
              alt="badge"
              width={20}
              className={styles.badge}
            />
          </div>
        </div>
        <div className={styles.animation}>
          <div className={styles.animationInner}>
            <div className={styles.animationItem}>
              <div className={styles.animationItemFlex}>
                <div
                  className={styles.animationItemImg}
                  style={{
                    backgroundImage: `url(https://xiuxiupro-material-center.meitudata.com/material/image/6761622898f645678.webp)`,
                  }}
                />
                <div
                  className={styles.animationItemImg}
                  style={{
                    backgroundImage: `url(https://xiuxiupro-material-center.meitudata.com/material/image/6761623d764052236.webp)`,
                  }}
                />
              </div>
              <div className={styles.animationItemFlex}>
                <div
                  className={styles.animationItemImg}
                  style={{
                    backgroundImage: `url(https://xiuxiupro-material-center.meitudata.com/material/image/6761625021e239641.webp)`,
                  }}
                />
                <div
                  className={styles.animationItemImg}
                  style={{
                    backgroundImage: `url(https://xiuxiupro-material-center.meitudata.com/material/image/67628f7d8b6de8861.webp)`,
                  }}
                />
              </div>
            </div>
            <div className={styles.animationSubTitle}>动态素材模板</div>
          </div>
          <div className={styles.animationInner}>
            <div className={styles.animationVideoItem}>
              <video
                src="https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/0a0caf0653023a7c0b090f82b87a8ed9 (1).mp4"
                autoPlay
                muted
                loop
                playsInline
                webkit-playsinline="true"
                x5-playsinline="true"
              />
            </div>
            <div className={styles.animationSubTitle}>一键开启演示动画</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default React.memo(Module);
